import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import MiniLoader from "components/MiniLoader";
import { CSVLink, CSVDownload } from "react-csv";
import { EntryModal, Row, EntryStrategyModal } from './components';
import { connect } from "react-redux";
import * as actions from "redux/actions/optionOrderActions";
import * as quoteActions from "redux/actions/quoteActions";
import useStockQuotes from "hooks/useStockQuotes";
import useOptionQuotes from "hooks/useOptionQuotes";
import { Translate, I18n } from "react-redux-i18n";
import axios from "axios";
import { config } from "config";
import { getApiHeaders } from "api/apiHeaders";

const useStyles = {
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 800
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  status: {
    // marginRight: theme.spacing(1)
  },
  actions: {
    justifyContent: 'flex-end'
  }
};

const statusColors = {
  delivered: 'success',
  pending: 'info',
  refunded: 'danger'
};
function getCountContracts(rows) {
  var cap = 0;
  var count = 0;
  rows.forEach(item => {
    const subOrders = Array.isArray(item.sub_order) ? item.sub_order : [];
    const isGrouped = Number(item.counter) > 1 || subOrders.length > 1;
    if (!isGrouped) {
      cap += Number(item.open_trade) || 0;
      count++;
    }
    else {
      subOrders.forEach(item_ => {
        const nested = Array.isArray(item_.sub_order) ? item_.sub_order : [];
        const isNestedGrouped = Number(item_.counter) > 1 || nested.length > 1;
        if (!isNestedGrouped) {
          cap += Number(item_.open_trade) || 0;
          count++;
        }
        else {
          nested.forEach(item__ => {
            cap += Number(item__.open_trade) || 0;
            count++;
          });
        }
      });
    }
  });

  return "Contract " + count + " = $" + Number(cap).toFixed(2) + " USD";
}

function formatVix(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) {
    return null;
  }
  return n.toFixed(2);
}

function formatVixChange(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return null;
  }
  const abs = Math.abs(n).toFixed(2);
  if (n > 0) return `+${abs}`;
  if (n < 0) return `-${abs}`;
  return abs;
}

/** VIX regime bands used for the portfolio badge. */
function resolveVixLevel(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) {
    return null;
  }
  if (n < 15) {
    return { key: 'low', tone: 'low' };
  }
  if (n <= 20) {
    return { key: 'normal', tone: 'normal' };
  }
  if (n < 25) {
    return { key: 'high', tone: 'high' };
  }
  if (n < 40) {
    return { key: 'very_high', tone: 'very-high' };
  }
  return { key: 'extreme', tone: 'extreme' };
}

const OptionOrders = props => {
  const { className, list, ...rest } = props;
  const [vix, setVix] = useState(null);


  //const [list, setList] = useState(props.list);

  useEffect(() => {
    if (props.list.length === 0)
      props.loadList(props.user_id, props.token);
  }, []);

  useEffect(() => {
    if (!props.user_id) {
      return undefined;
    }

    let cancelled = false;
    const refreshVix = async () => {
      try {
        const response = await axios.get(`${config.api.web}market/vix`, {
          headers: getApiHeaders(),
        });
        if (cancelled) {
          return;
        }
        if (response.status < 300 && response.data?.status === 'Success') {
          setVix(response.data.body || null);
        }
      } catch (error) {
        if (!cancelled) {
          console.error('loadVix', error.response?.data?.body || error.message);
        }
      }
    };

    refreshVix();
    const interval = setInterval(refreshVix, 60000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [props.user_id]);

  useStockQuotes(props.list, props.user_id, props.token, props.loadStockQuotes);
  useOptionQuotes(props.list, props.user_id, props.token, props.loadOptionQuotes);

  const vixPrice = Number(vix?.price);
  const vixChange = Number(vix?.change);
  const vixLabel = formatVix(vixPrice);
  const vixChangeLabel = formatVixChange(vixChange);
  const vixLevel = resolveVixLevel(vixPrice);

  const headers = [
    { label: "Symbol", key: "symbol" },
    { label: "Open Date", key: "open_at" },
    { label: "Qtt", key: "quantity" },
    { label: "Stk", key: "strike" },
    { label: "Open Prc", key: "open_price" },
    { label: "Open Trd", key: "open_trade" },
    { label: "BE", key: "" },
    { label: "Exp", key: "expire_at" },
    { label: "DTE", key: "" },
    { label: "Ext", key: "" },
    { label: "NetLiq", key: "" },
    { label: "P/L", key: "" },
    { label: "P/L%", key: "" },
    { label: "Reference", key: "reference" },
  ];

  const dataCsv = () => {
    let data = [];
    /* props.list.forEach(element => {
       var item = {};
       if (element.counter === 1)
         headers.forEach(ref => {
           item = {
             ...item,
             [ref.key]: element[ref.key]
           };
         });
       else
         element.sub_order.forEach(subElement => {
           headers.forEach(ref => {
             item = {
               ...item,
               [ref.key]: subElement[ref.key]
             };
           });
         });
 
       data = data.concat(item);
     });*/
    return data;
  }

  return (
    <div className=''>

        <div className="portfolio-toolbar">
          <span className="portfolio-summary">
          {getCountContracts(props.list || [])}
          </span>
           <div className="portfolio-toolbar-actions">
            {vixLabel && (
              <span
                className={`portfolio-vix${vixChange > 0 ? ' is-up' : ''}${vixChange < 0 ? ' is-down' : ''}${vixLevel ? ` is-${vixLevel.tone}` : ''}`}
                title={I18n.t(`portfolio_vix_level_${vixLevel?.key || 'normal'}_hint`)}
              >
                {vixLevel && (
                  <span className="portfolio-vix-level">
                    <Translate value={`portfolio_vix_level_${vixLevel.key}`} />
                  </span>
                )}
                <span className="portfolio-vix-label">VIX</span>
                <span className="portfolio-vix-value">{vixLabel}</span>
                {vixChangeLabel && (
                  <span className="portfolio-vix-change">{vixChangeLabel}</span>
                )}
              </span>
            )}
            <EntryStrategyModal />
            <EntryModal />
          </div>
        </div>


      <div className='divider' />
      
      <div className={''}>
            <table className="table table-hover portfolio-sticky-table">
              <thead>
                <tr>
                  <th >
                    <span className="tooltip">
                      Symbol
                      <span className="tooltiptext">Sort</span>
                    </span>
                  </th>
                  <th>Last</th>
                  <th>Open Date</th>
                  <th align="right">
                    Qtt
                  </th>
                  <th align="right">Stk</th>
                  <th align="right">Open Prc</th>
                  <th align="right">Open Trd</th>
                  <th align="right">BE</th>
                  <th>Exp</th>
                  <th align="right">DTE</th>
                  <th align="right">NetLiq</th>
                  <th align="right">P/L</th>
                  <th align="right">P/L%</th>
                  <th>Reference</th>
                  <th>RollAccum</th>
                  <th>Act</th>
                </tr>
              </thead>
              <tbody>
                {props.list.map((order, index) => (
                  <Row key={index} order={order} />
                ))}
              </tbody>
            </table>
        
      </div>
      <div className='divider' />
      {
        props.loading ? (
          <div className='card-actions' style={{ "justifyContent": "center", }}>
            <MiniLoader />
          </div>
        ) : <div className={'useStyles.actions'}>
              <CSVLink
                data={dataCsv()}
                separator={";"}
                headers={headers}
                className="btn btn-primary"
                filename={"Ebi_stock_" + new Date().getTime() + ".csv"}
              > <Translate value="download" /> CSV
              </CSVLink>
            </div>
      }
    </div>
  );
};

OptionOrders.propTypes = {
  className: PropTypes.string
};

function mapStateToProps(reducer) {
  //console.log(reducer);
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,

    list: reducer.optionOrder.list,
    error: reducer.optionOrder.error,
    loading: reducer.optionOrder.loading,
  };
}
const mapDispatchToProps = dispatch => ({
  loadList: (user_id, token) =>
    dispatch(actions.loadList({ user_id, token })),
  loadStockQuotes: (symbols, user_id, token) =>
    dispatch(quoteActions.loadStockQuotes({ symbols, user_id, token })),
  loadOptionQuotes: (tickers, user_id, token) =>
    dispatch(quoteActions.loadOptionQuotes({ tickers, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(OptionOrders);
/**
 * <Button
          color="primary"
          size="small"
          variant="text"
          target="_blank"
        >
          Download PDF <ArrowRightIcon />
        </Button>
 *   <Button
                        color="secondary"
                        variant="contained"
                        size="small"
                      //   onClick={() => { onClickDelete(item) }}
                      >
                        {"R"}
                      </Button>
                      {" "}
 *  <div className={classes.statusContainer}>
                        <StatusBullet
                          className={classes.status}
                          color={statusColors[order.status]}
                          size="sm"
                        />
                        {order.status}
                      </div>
 <Button
            color="primary"
            size="small"
            variant="outlined"
          >
            Option entry
          </Button>


                  

 */
